import { store } from 'redux/store';
import { useCallback, useEffect, useState } from 'react';
import { getOperations } from '../redux/operationActions';
import { excludedOps } from '../pages/TransactionsList/hooks/useTransactionsList';

type UseGetOperationsProps = {
  societyId: string | undefined;
  partnerId: string | undefined;
  page: number;
  items: number;
  sortBy?: string;
  sortOrder?: string;
  filterBy?: string | string[];
};

const DEFAULT_SORT_BY = 'date';
const DEFAULT_SORT_ORDER = 'desc';

export const useGetOperations = ({
  societyId,
  partnerId,
  page,
  items,
  filterBy = '',
  sortBy = DEFAULT_SORT_BY,
  sortOrder = DEFAULT_SORT_ORDER,
}: UseGetOperationsProps) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const fetchOperations = useCallback(async () => {
    if (!societyId || partnerId) return;

    setIsLoading(true);
    setIsError(false);

    try {
      const excludedOperations = excludedOps;
      const params = {
        page,
        items,
        filterBy,
        sortBy,
        sortOrder,
        excludedOperations,
      };

      await store.dispatch(getOperations(societyId, params));
    } catch (error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  }, [societyId, partnerId, page, items, filterBy]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchOperations();
  }, [fetchOperations]);

  return {
    isLoading,
    isError,
  };
};
